// Textos de flotas de taxi/VTC (docs/flotas-drivers). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'es',
  data: {
    DRIVERS_FLEET: {
      MODE: {
        taxi: 'Taxi',
        vtc: 'VTC',
      },
      FLEET_STATUS: {
        draft: 'Alta sin enviar',
        in_review: 'En revisión',
        rejected: 'Rechazada',
        approved: 'Aprobada',
        suspended: 'Suspendida',
      },
      DOC_STATUS: {
        pending: 'Pendiente',
        in_review: 'En revisión',
        approved: 'Aprobado',
        rejected: 'Rechazado',
        expired: 'Caducado',
        expiring_soon: 'Caduca pronto',
      },
      EXPIRY: {
        none: 'Sin caducidad',
        valid: 'Caduca el {{date}}',
        expiring_soon: 'Caduca pronto: {{date}}',
        expired: 'Caducó el {{date}}',
      },
      OWNER_TYPE: {
        fleet: 'Flota',
        vehicle: 'Vehículo',
        driver: 'Conductor',
      },
      DOC_TYPE: {
        billing_info: 'Datos de facturación',
        bank_ownership_certificate: 'Certificado de titularidad bancaria',
        route_sheet_authorization: 'Apoderamiento de hojas de ruta',
        circulation_permit: 'Permiso de circulación',
        technical_sheet_itv: 'Ficha técnica con ITV en vigor',
        insurance_policy: 'Póliza del seguro del vehículo',
        taxi_municipal_license: 'Licencia municipal de taxi',
        vtc_transport_card: 'Tarjeta de transporte VTC',
        identity: 'Verificación de identidad',
        driving_license: 'Carnet de conducir',
        taxi_driver_card: 'Carnet de conductor de autotaxi',
        vtc_driver_permit: 'Permiso de conductor VTC',
        social_security_registration: 'Alta en la Seguridad Social',
      },
      REJECTION_REASON: {
        illegible: 'Ilegible',
        expired: 'Caducado',
        holder_mismatch: 'No coincide el titular',
        plate_mismatch: 'No coincide la matrícula',
        wrong_document: 'Documento incorrecto',
        other: 'Otro motivo',
      },
      ROLE: {
        fleet_owner: 'Propietario',
        fleet_manager: 'Gestor',
        fleet_accountant: 'Contable',
      },
      MEMBERSHIP_STATUS: {
        pending: 'Solicitud pendiente',
        accepted: 'Aceptado',
        rejected: 'Rechazado',
        removed: 'Desvinculado',
      },
      EMPLOYMENT_TYPE: {
        salaried: 'Asalariado',
        self_employed: 'Autónomo',
      },
      VEHICLE_STATUS: {
        incomplete: 'Faltan documentos',
        in_review: 'En revisión',
        rejected: 'Rechazado',
        approved: 'Aprobado',
      },
      SHIFT_SLOT: {
        morning: 'Mañana',
        afternoon: 'Tarde',
        night: 'Noche',
      },
      UPLOAD: {
        HINT: 'JPG, PNG o PDF, hasta 30 MB.',
        SUBMIT: 'Subir',
        RESUBMIT: 'Volver a subir',
        UPLOADING: 'Subiendo…',
        ERROR_TYPE: 'El archivo debe ser JPG, PNG o PDF.',
        ERROR_SIZE: 'El archivo no puede superar 30 MB.',
      },
      VIEWER: {
        EMPTY: 'Todavía no se ha subido este documento.',
        NO_PREVIEW: 'No se puede previsualizar este archivo.',
        OPEN: 'Abrir en una pestaña nueva',
      },
      ONBOARDING_STATUS: {
        in_progress: 'Alta a medias',
        in_review: 'En revisión',
        rejected: 'Algo rechazado',
        approved: 'Aprobado',
      },
      WORKING_AS: {
        own_license: 'Licencia propia',
        fleet_self_employed: 'Autónomo en flota',
        fleet_salaried: 'Asalariado en flota',
      },
      DOC_SHORT: {
        circulation_permit: 'Circulación',
        technical_sheet_itv: 'ITV',
        insurance_policy: 'Seguro',
        taxi_municipal_license: 'Licencia',
        vtc_transport_card: 'Tarjeta VTC',
      },
      ADMIN: {
        LOADING: 'Cargando…',
        RETRY: 'Reintentar',
        OPEN: 'Abrir',
        VIEW: 'Ver',
        REVIEW_ACTION: 'Revisar',
        PREVIOUS: 'Anterior',
        NEXT: 'Siguiente',
        YES: 'Sí',
        NO: 'No',
        MODE_ALL: 'Taxi y VTC',
        MODE_ARIA: 'Taxi o VTC',
        REGION_ALL: 'Todas las regiones',
        REGION_ARIA: 'Región',
        COL_MODE: 'Modo',
        COL_REGION: 'Región',
        COL_STATUS: 'Estado',
        COL_CREATED: 'Alta',
        CAN_WORK: 'Puede trabajar',
        OWN_LICENSE: 'Licencia propia',
        DOCS_APPROVED: '{{approved}} de {{total}} aprobados',
        DOCS_IN_REVIEW: '{{count}} en revisión',
        DOCS_REJECTED: '{{count}} rechazados',
        BILLING: 'Facturación',
        BILLING_LEGAL_NAME: 'Razón social',
        BILLING_TAX_ID: 'NIF',
        BILLING_ENTITY: 'Factura como',
        BILLING_ENTITY_company: 'Empresa',
        BILLING_ENTITY_self_employed: 'Autónomo',
        BILLING_ADDRESS: 'Domicilio fiscal',
        BILLING_VAT: 'Régimen de IVA',
        BILLING_NONE: 'Todavía no ha rellenado los datos de facturación.',
        VAT_general: 'General',
        VAT_simplified: 'Simplificado',
        VAT_exempt: 'Exento',
        REVIEWS: {
          TABS_ARIA: 'Estado de la revisión',
          TAB_IN_REVIEW: 'Pendientes',
          TAB_APPROVED: 'Aprobados',
          TAB_REJECTED: 'Rechazados',
          PANEL_TITLE_in_review: 'Pendientes de revisar',
          PANEL_TITLE_approved: 'Documentos aprobados',
          PANEL_TITLE_rejected: 'Documentos rechazados',
          PANEL_SUB_in_review: 'Los que más llevan esperando, primero. Al abrir uno se ve el archivo junto a sus datos.',
          PANEL_SUB_approved: 'Documentos ya aprobados, con su fecha de caducidad.',
          PANEL_SUB_rejected: 'Documentos rechazados y el motivo que se le dio al usuario.',
          SEARCH: 'Buscar flota, conductor o matrícula',
          OWNER_ALL: 'Quién lo sube: todos',
          OWNER_ARIA: 'Quién lo sube',
          TYPE_ALL: 'Todos los documentos',
          TYPE_ARIA: 'Tipo de documento',
          SORT_OLDEST: 'Más antiguos primero',
          SORT_NEWEST: 'Más recientes primero',
          SORT_ARIA: 'Orden',
          COL_DOCUMENT: 'Documento',
          COL_OWNER: 'De',
          COL_OWNER_TYPE: 'Tipo',
          COL_UPLOADED: 'Subido',
          VERSION: 'Versión {{version}}',
          OWN_LICENSE_OF: 'Licencia propia de {{name}}',
          EMPTY_in_review: 'No hay documentos pendientes de revisar.',
          EMPTY_approved: 'Todavía no hay documentos aprobados.',
          EMPTY_rejected: 'No hay documentos rechazados.',
          EMPTY_FILTERED: 'Ningún documento coincide con los filtros.',
          LOAD_ERROR: 'No se han podido cargar los documentos.',
          SHOWING: 'Mostrando {{shown}} de {{total}} documentos',
          PER_PAGE: '{{count}} por página',
          PER_PAGE_ARIA: 'Documentos por página',
        },
        REVIEW: {
          TITLE: 'Revisión de documento',
          BACK: 'Volver a la cola',
          NEXT_PENDING: 'Siguiente pendiente',
          LOAD_ERROR: 'No se ha podido cargar el documento.',
          DOCUMENT: 'Documento',
          UPLOADED: 'Subido el {{date}} por {{name}}',
          REVIEW: 'Revisión',
          APPROVE_TITLE: 'Aprobar',
          APPROVE_HELP_NONE: 'Este documento no caduca ni lleva número: basta con comprobar que es correcto.',
          EXPIRES_AT: 'Fecha de caducidad',
          EXPIRES_HINT: 'Con ella se avisa a la flota de que caduca pronto o ha caducado.',
          EXPIRES_REQUIRED: 'Indica la fecha de caducidad.',
          LICENSE_NUMBER: 'Nº de licencia',
          AUTHORIZATION_NUMBER: 'Nº de autorización',
          LICENSE_REQUIRED: 'Indica el número que aparece en el documento.',
          APPROVE: 'Aprobar documento',
          APPROVING: 'Aprobando…',
          REJECT_TITLE: 'Rechazar',
          REASON: 'Motivo',
          REASON_PLACEHOLDER: 'Elige un motivo',
          REASON_REQUIRED: 'Elige el motivo del rechazo.',
          COMMENT: 'Comentario',
          COMMENT_PLACEHOLDER: 'Qué tiene que corregir, en una frase.',
          COMMENT_HINT: 'El usuario lo verá junto al motivo.',
          COMMENT_REQUIRED: 'Con «Otro motivo», explica qué pasa.',
          REJECT: 'Rechazar documento',
          REJECTING: 'Rechazando…',
          DONE_APPROVED: 'Documento aprobado. Se ha avisado al usuario.',
          DONE_REJECTED: 'Documento rechazado. Se ha avisado al usuario con el motivo.',
          NO_MORE_PENDING: 'No quedan más documentos pendientes.',
          ALREADY_REVIEWED: 'Otra persona ya había revisado este documento. Se muestra su decisión.',
          ACTION_ERROR: 'No se ha podido guardar la revisión.',
          REVIEWED_BY: 'Revisado por',
          OWNER: 'De quién es',
          IDENTITY: 'Identidad (Tecalis)',
          IDENTITY_BY: 'el {{date}}',
          IDENTITY_NONE: 'Sin verificar todavía',
          HISTORY: 'Historial',
          HISTORY_uploaded: 'Subido por {{name}}',
          HISTORY_approved: 'Aprobado por {{name}}',
          HISTORY_rejected: 'Rechazado por {{name}}',
          PREVIOUS_VERSIONS: 'Versiones anteriores',
        },
        FLEETS: {
          TABS_ARIA: 'Estado de la flota',
          TAB_ALL: 'Todas',
          PANEL_TITLE: 'Todas las flotas',
          PANEL_SUB: 'Una flota puede trabajar cuando todos sus documentos de empresa están aprobados.',
          SEARCH: 'Buscar por nombre, correo o código',
          COL_FLEET: 'Flota',
          COL_VEHICLES: 'Vehículos',
          COL_DRIVERS: 'Conductores',
          COL_REQUESTS: 'Solicitudes',
          EMPTY: 'No hay flotas que coincidan.',
          LOAD_ERROR: 'No se han podido cargar las flotas.',
          SHOWING: 'Mostrando {{shown}} de {{total}} flotas',
          PER_PAGE: '{{count}} por página',
          PER_PAGE_ARIA: 'Flotas por página',
        },
        FLEET: {
          APPROVE_BILLING: 'Aprobar datos',
          REJECT_BILLING: 'Rechazar',
          CONFIRM_REJECT_BILLING: 'Rechazar datos de facturación',
          TITLE: 'Ficha de la flota',
          BACK: 'Volver a flotas',
          LOAD_ERROR: 'No se ha podido cargar la flota.',
          CODE: 'Código',
          SUBMITTED: 'Enviada a revisión',
          NOT_SUBMITTED: 'Sin enviar',
          ONBOARDING: 'Alta de la flota',
          ONBOARDING_SUB: 'Datos de facturación y documentos de empresa.',
          VEHICLES: 'Vehículos',
          VEHICLES_SUB: 'Un vehículo puede trabajar cuando todos sus documentos están aprobados y al día.',
          NO_VEHICLES: 'Todavía no ha dado de alta ningún vehículo.',
          PLATE: 'Matrícula',
          CAR: 'Vehículo',
          DOCUMENTS: 'Documentos',
          DRIVERS: 'Conductores',
          DRIVERS_SUB: 'Vinculados por el código de flota.',
          NO_DRIVERS: 'Todavía no hay conductores vinculados.',
          RELATION: 'Relación',
          SHARE: 'Reparto',
        },
        DRIVERS: {
          TABS_ARIA: 'Estado del alta',
          TAB_ALL: 'Todos',
          PANEL_TITLE: 'Todos los conductores',
          PANEL_SUB: 'Un conductor no puede conectarse hasta que todos sus pasos están aprobados.',
          SEARCH: 'Buscar por nombre, correo, teléfono o flota',
          WORKING_AS_ALL: 'Cómo trabaja: todos',
          WORKING_AS_ARIA: 'Cómo trabaja',
          COL_WORKING_AS: 'Cómo trabaja',
          COL_STEPS: 'Pasos',
          EMPTY: 'No hay conductores que coincidan.',
          LOAD_ERROR: 'No se han podido cargar los conductores.',
          SHOWING: 'Mostrando {{shown}} de {{total}} conductores',
          PER_PAGE: '{{count}} por página',
          PER_PAGE_ARIA: 'Conductores por página',
        },
        DRIVER: {
          TITLE: 'Ficha del conductor',
          BACK: 'Volver a conductores',
          LOAD_ERROR: 'No se ha podido cargar el conductor.',
          VIEW_USER: 'Ver ficha de usuario',
          DOCUMENTS: 'Pasos del alta',
          DOCUMENTS_SUB: 'Documentos que ha subido desde la app.',
          OWN_VEHICLE: 'De su vehículo',
          IDENTITY_TECALIS: 'Lo verifica Tecalis',
          FLEETS: 'Flotas',
          NO_FLEETS: 'No ha estado en ninguna flota.',
        },
      },
      HUB: {
        SECTION: 'Flotas de taxi y VTC',
        NEW_SECTION: 'Nueva flota de taxi o VTC',
        CREATE_TITLE: 'Dar de alta una flota',
        CREATE_META: 'Gestiona tus licencias, vehículos y conductores de taxi o VTC.',
      },
      SIGNUP: {
        TITLE: 'Alta de una flota',
        SUBTITLE: 'Da de alta tu empresa de taxi o VTC. Después añadirás los vehículos y los conductores desde el panel.',
        BACK_TO_HUB: 'Volver al tablero',
        BACK: 'Atrás',
        STEP_OF: 'Paso {{step}} de {{total}}',
        NEXT: 'Siguiente',
        CREATE: 'Crear la flota',
        CREATING: 'Creando…',
        START_TITLE: 'Tu empresa',
        START_SUB: 'Dónde trabajas y cómo te escribimos.',
        NAME: 'Nombre de la flota',
        NAME_HINT: 'El nombre con el que te verán tus conductores.',
        NAME_REQUIRED: 'Escribe el nombre de la flota.',
        REGION: 'Ciudad',
        REGION_PLACEHOLDER: 'Elige la ciudad',
        REGION_REQUIRED: 'Elige la ciudad en la que trabaja la flota.',
        EMAIL: 'Correo de la empresa',
        EMAIL_HINT: 'Ahí te avisaremos de la revisión de los documentos.',
        EMAIL_INVALID: 'Escribe un correo válido.',
        CATALOG_ERROR: 'No se han podido cargar las ciudades.',
        ACTIVITY_TITLE: '¿A qué se dedica la flota?',
        ACTIVITY_SUB: 'Una flota es de taxi o de VTC: decide qué documentos se piden.',
        ACTIVITY_REQUIRED: 'Elige a qué se dedica la flota.',
        MODE_NOTE_TITLE: 'No se puede cambiar después',
        MODE_NOTE_TEXT: 'Taxi y VTC no se mezclan en una misma flota. Si tienes las dos actividades, da de alta una flota para cada una.',
        CREATE_ERROR: 'No se ha podido crear la flota.',
      },
      ONBOARDING: {
        SUBTITLE_DRAFT: 'Completa los pasos y envíalos a revisión. Los vehículos se añaden después, desde el panel.',
        SUBTITLE_SENT: 'El estado de cada paso de tu alta.',
        GO_TO_PANEL: 'Ir al panel',
        PROGRESS: '{{done}} de {{total}} pasos completados',
        CATALOG_ERROR: 'No se han podido cargar los datos del alta.',
        STEP_HINT_billing_info: 'Entidad, razón social, NIF, dirección e IVA.',
        STEP_HINT_bank_ownership_certificate: 'A nombre de la empresa y con el IBAN visible.',
        STEP_HINT_route_sheet_authorization: 'Autoriza a WAIIS en el Registro VTC del Ministerio.',
        STEP_pending: 'Pendiente',
        STEP_ready: 'Listo',
        STEP_in_review: 'En revisión',
        STEP_approved: 'Aprobado',
        STEP_rejected: 'Rechazado',
        STATUS_TITLE_draft: 'Alta sin enviar',
        STATUS_TITLE_in_review: 'Flota en revisión',
        STATUS_TITLE_rejected: 'Hay algo que corregir',
        STATUS_TITLE_approved: 'Flota aprobada',
        STATUS_TITLE_suspended: 'Flota suspendida',
        STATUS_TEXT_draft: 'Completa los pasos y envía el alta.',
        STATUS_TEXT_in_review: 'Estamos revisando tus documentos. Mientras tanto puedes entrar al panel, pero tus conductores no podrán conectarse hasta que la flota esté aprobada.',
        STATUS_TEXT_rejected: 'Revisa el paso rechazado, corrige lo que se indica y vuelve a subirlo.',
        STATUS_TEXT_approved: 'Tu flota está aprobada. Ya puedes trabajar con ella.',
        STATUS_TEXT_suspended: 'Ponte en contacto con WAIIS para reactivarla.',
        REJECTED_FIX: 'Corrígelo y vuelve a subirlo.',
        LOCKED_STEP: 'Este paso ya está enviado. Si lo rechazamos, podrás volver a subirlo.',
        ENTITY_REQUIRED: 'Elige si facturas como empresa o como autónomo.',
        FIELD_REQUIRED: 'Este campo es obligatorio.',
        TAX_ID_INVALID: 'El NIF debe tener 9 caracteres.',
        POSTAL_CODE: 'Código postal',
        POSTAL_CODE_INVALID: 'El código postal tiene 5 cifras.',
        CITY: 'Localidad',
        PROVINCE: 'Provincia',
        VAT_PLACEHOLDER: 'Elige el régimen de IVA',
        SAVE: 'Guardar datos',
        SAVING: 'Guardando…',
        SAVE_ERROR: 'No se han podido guardar los datos.',
        UPLOAD_ERROR: 'No se ha podido subir el documento.',
        BANK_TEXT: 'Sube el certificado de titularidad de la cuenta bancaria de la empresa. Tiene que estar a nombre de la empresa y verse el IBAN completo.',
        ROUTE_SHEET_TEXT: 'Para poder emitir las hojas de ruta de tus servicios, autoriza a WAIIS en el Registro de VTC del Ministerio y sube la captura de la autorización.',
        MISSING_STEPS: 'Completa todos los pasos para enviar el alta.',
        SUBMIT: 'Enviar a revisión',
        SUBMITTING: 'Enviando…',
        SUBMIT_ERROR: 'No se ha podido enviar el alta.',
      },
      OVERVIEW: {
        SUBTITLE: 'Lo más importante de tu flota de un vistazo.',
        SEE_ONBOARDING: 'Ver el alta',
        CODE_TITLE: 'Código de flota',
      },
    },
    // Menú y cabeceras de Admin › Taxi y VTC (se fusionan con los generales).
    SIDEBAR: {
      FLEET_SECTION: 'Mi flota',
      FLEET_ONBOARDING: 'Alta de la flota',
      FLEET_OVERVIEW: 'Resumen',
      FLEET_DRIVERS: 'Conductores',
      FLEET_VEHICLES: 'Vehículos',
      FLEET_SHIFTS: 'Turnos',
      FLEET_DOCUMENTS: 'Documentos',
      FLEET_MONEY_SECTION: 'Dinero',
      FLEET_SETTLEMENTS: 'Liquidaciones',
      FLEET_REPORTS: 'Informes',
      FLEET_ADMIN_SECTION: 'Administración',
      FLEET_TEAM: 'Equipo',
      FLEET_SETTINGS: 'Ajustes',
      FLEET_LOCKED_DRAFT: 'Completa y envía el alta de la flota para usar esta sección.',
      DRIVERS_PRO: 'Taxi y VTC',
      DOCUMENT_REVIEWS: 'Verificación de documentos',
      FLEETS: 'Flotas',
      PROFESSIONAL_DRIVERS: 'Conductores profesionales',
    },
    PAGE_HEADER: {
      DOCUMENT_REVIEWS: 'Revisa a mano los documentos que suben las flotas y los conductores de taxi y VTC. El DNI lo verifica Tecalis.',
      FLEETS: 'Flotas de taxi y VTC dadas de alta, con el estado de su revisión, sus vehículos y sus conductores.',
      PROFESSIONAL_DRIVERS: 'Conductores de taxi y VTC con licencia propia o vinculados a una flota, y el estado de su alta.',
    },
  },
};
